import React, { useEffect } from 'react';
import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { initPerformanceMonitoring } from '@/utils/performanceMonitor';

export default function ConsentAwarePerformanceMonitor() {
  const { canUseAnalytics } = useCookieConsent();
  const analyticsEnabled = canUseAnalytics();

  useEffect(() => {
    if (analyticsEnabled) {
      initPerformanceMonitoring();
    }
  }, [analyticsEnabled]);

  return null;
}

